module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id=\'MAIN_BOX\'>\n	<div id=\'SCREEN_BOX\'></div>\n	<div id=\'EXTRA_BOX\'>\n		<div id=\'event_log_box\'></div>\n		<div id=\'alarm_list_box\'></div>\n	<div id=\'MENU_BOX\'></div>\n</div>\n</div>\n\n\n<!-- extra containers used for other stuff -->\n<div id=\'EDIT_BOX\'></div>\n<div id=\'TOOLTIP_BOX\'></div>\n';
}
return __p;
};
